import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { map, catchError } from 'rxjs/operators';
import { SearchResult, Result } from './models/search-result';
import { ReferenceSearchParams } from './models/reference-search-params';
import { Category } from './models/category.model';
import { Reference } from './models/reference.model';
import { ReferenceType } from './models/reference-types.model';
import { Template } from './models/template.model';

@Injectable()
export class AppService {

  languages = new BehaviorSubject<Array<string>>([]);
  selectedLang = new BehaviorSubject<string>('en');
  searchResult = new BehaviorSubject<SearchResult>(null);
  categories = new BehaviorSubject<Array<Category>>([]);
  reference = new BehaviorSubject<Reference>(null);
  referenceTypes = new BehaviorSubject<Array<ReferenceType>>([]);
  template = new BehaviorSubject<Template>(null);

  constructor(
    private apiService: ApiService
  ) { }

  getLanguages() {
    return this.apiService.get('/api/MasterData/SupportedLanguages', 'json', true).pipe(
      map(
        (data: Array<string>) => {
          this.languages.next(data);

          return data;
        }
      )
    );
  }

  getCategories() {
    return this.apiService.get('/api/MasterData/Categories', 'json', true).pipe(
      map(
        (data: Array<Category>) => {
          this.categories.next(data);

          return data;
        }
      )
    );
  }

  getReference(id) {
    return this.apiService.get('/api/References/' + id, 'json', true).pipe(
      map(
        (data: Reference) => {
          this.reference.next(data);

          return data;
        }
      )
    );
  }

  getReferenceTypes() {
    return this.apiService.get('/api/MasterData/ReferenceTypes', 'json', true).pipe(
      map(
        (data: Array<ReferenceType>) => {
          this.referenceTypes.next(data);

          return data;
        }
      )
    );
  }

  getTemplateByReferenceType(id) {
    return this.apiService.get('/api/References/Template/' + id, 'json', true).pipe(
      map(
        (data: Template) => {
          this.template.next(data);

          return data;
        }
      )
    );
  }

  searchReference(search: ReferenceSearchParams) {
    return this.apiService.post('/api/References/Search/Admin', search, 'json', true).pipe(
      map(
        (data: SearchResult) => {
          this.searchResult.next(data);

          return data;
        }
      )
    );
  }

  createReference(reference: Reference) {
    return this.apiService.post('/api/References', reference, 'json', true).pipe(
      map(
        (data: Reference) => {
          this.reference.next(data);

          return data;
        }
      )
    );
  }

  updateReference(reference: Reference) {
    return this.apiService.put('/api/References', reference, 'json', true).pipe(
      map(
        (data: Reference) => {
          this.reference.next(data);

          return data;
        }
      )
    );
  }

  deleteReference(referenceId: string) {
    return this.apiService.delete('/api/References/' + referenceId, {}, 'json', true).pipe(
      map(
        (data) => {

          return data;
        }
      )
    );
  }

  deleteReferenceImage(referenceImageId: string) {
    return this.apiService.delete('/api/References/Images/' + referenceImageId, {}, 'json', true).pipe(
      map(
        (data) => {

          return data;
        }
      )
    );
  }

  getExport(referenceId, type) {
    const format = type === 'word' ? '/DOCX' : '/PDF';
    // tslint:disable-next-line:max-line-length
    return this.apiService.getTxt('/api/References/' + referenceId + format, 'json', true).pipe(
      map(
        data => {
          console.log(data);
          return data;
        }
      ),
      catchError(
        (err) => {
          console.log(err);

          return Observable.throw(err);
        }
      )
    );
  }

}
